var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115,180 L115,172 C115,171.447715 115.447715,171 116,171 C116.552285,171 117,171.447715 117,172 L117,180 L125,180 C125.552285,180 126,180.447715 126,181 C126,181.552285 125.552285,182 125,182 L117,182 L117,190 C117,190.552285 116.552285,191 116,191 C115.447715,191 115,190.552285 115,190 L115,182 L107,182 C106.447715,182 106,181.552285 106,181 C106,180.447715 106.447715,180 107,180 L115,180 Z",
    transform: "translate(-104 -169)",
    fillRule: "evenodd"
  })));
};
export default SvgPlus;